import { lazy } from 'react';

export const WishlistList = lazy(() => import('./wishlist/WishlistList'));
export const CartList = lazy(() => import('./cart/CartList'));
export const OrderList = lazy(() => import('./order/OrderList'));
export const OrderDetails = lazy(() => import('./order/OrderDetails'));
export const ContactUsList = lazy(() => import('./contact_us/ContactUsList'));